module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gSzYx"))).then(() => parcelRequire('ikE14'));